import { useEffect, useState } from 'react';

export const useHtmlImage = (url?: string): HTMLImageElement | null => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  useEffect(() => {
    setImage(null);
    if (!url) return;
    const next = new window.Image();
    next.crossOrigin = 'anonymous';
    next.onload = () => setImage(next);
    next.onerror = () => setImage(null);
    next.src = url;
    return () => { next.onload = null; next.onerror = null; };
  }, [url]);
  return image;
};
